<template>
  <div>
    <container v-if="screen.width >= 990" />

    <containerMobile v-if="screen.width <= 989" />
  </div>
</template>

<script>
import Container from "@/components/Container";
import ContainerMobile from "@/components/mobile/Container";

export default {
  name: "index",
  components: {
    Container,
    ContainerMobile
  },
  data: () => ({
    screen: {
      width: 0
    }
  }),
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  // created() {
  //   window.addEventListener("resize", this.handleResize);
  //   this.handleResize();
  // },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.screen.width = window.innerWidth;
    }
  }
};
</script>

<style lang="scss">
body {
  font-family: $font__primary;
  font-size: $size__text-primary;
  color: $color__text-primary;
  overflow-x: hidden;
  margin: 0;

  @media (max-width: 575.98px) {
    font-size: $size__text-primary-mobile;
  }

  @media (max-width: 1199px) {
    font-size: 17px;
  }

  &.modal-open {
    overflow: hidden;
  }
}

* {
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  box-shadow: none;
  box-sizing: border-box;
}

a {
  text-decoration: none;

  &.text-link {
    text-decoration: none;
    color: $color__text-primary;
    background: $color__green;

    &:hover {
      background: $color__purple;
      text-decoration: underline;
    }
  }
}

.h1,
h1 {
  @media (max-width: 575.98px) {
    font-size: $size__text__title__mobile;
  }

  @media (max-width: 1199px) {
    font-size: 30px;
  }

  font-size: $size__text__title__pc;
  font-family: $font__secondary;
  font-weight: 500;
  text-transform: uppercase;

  div {
    @extend .text-bg-green;
    white-space: pre;
    font-family: $font__secondary;
    display: inline-block;

    @media (max-width: 575.98px) {
      margin-bottom: 5px;
    }

    margin-bottom: 16px;
  }
}

h2,
.h2 {
  font-family: $font__secondary;
  font-weight: 500;
}

h3,
.h3 {
  font-weight: bold;
  font-size: 21px;
  font-weight: 500;
  text-transform: uppercase;
  background: #ffffff;
  font-family: $font__secondary;
}

p {
  line-height: 1.9;
  background: #ffffff;
}

.btn {
  display: inline-block;
  font-family: $font__secondary;
  height: 50px;
  line-height: 50px;
  padding: 0 20px;
  white-space: nowrap;
  border-radius: 11px;
  font-size: $size__text__button;
  font-weight: 800;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  cursor: pointer;
  transition: all 0.15s;
  transform: scale(1);
  box-shadow: 5px 5px 0 $color__green;

  &:hover:not([disabled]) {
    transform: scale(0.98);
  }

  &:active:not([disabled]) {
    transform: scale(0.85);
  }

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @mixin btn($color, $color2, $name) {
    &-#{$name} {
      @extend .btn;
      color: $color;
      background: $color2;
    }

    &-#{$name}-outline {
      @extend .btn;
      color: $color2;
      background: $color;
      border: 2px solid;
    }
  }

  @include btn(#fff, $color__text-primary, primary);
  @include btn(#fff, $color__info, info);
  @include btn(#fff, $color__success, success);
  @include btn($color__primary, #fff, white);
}
</style>